import { createClient } from '@supabase/supabase-js';
import type { Database } from '../types/supabase';

// Environment variables would typically come from .env files
// In a production app, these would be properly handled by Vite
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

export const supabase = createClient<Database>(supabaseUrl, supabaseKey);

/**
 * Wrapper to handle network errors gracefully
 * Prevents console errors and connection refused messages when offline
 */
export async function safeSupabaseCall<T>(
  operation: () => Promise<T>,
  fallback?: T
): Promise<T | null> {
  // Check if online before making request
  if (!navigator.onLine) {
    console.info('Offline: Skipping network request');
    return fallback ?? null;
  }

  try {
    return await operation();
  } catch (error) {
    // Suppress network errors to prevent console spam
    if (
      error instanceof TypeError &&
      (error.message.includes('fetch') || 
       error.message.includes('Network') ||
       error.message.includes('Failed to fetch'))
    ) {
      console.info('Network error suppressed:', error.message);
      return fallback ?? null;
    }
    
    // Re-throw non-network errors
    throw error;
  }
}